module.exports = __webpack_public_path__ + "static/media/20200102_103739.231009fa.jpg";